export default {
    getLang: function(){
        return $('html').attr('lang');
    },
    isSsl: function(){
        return (location.protocol === 'https:');
    },
    patterns: function() {
        return {
            email: /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
            name: /^[\u00c0-\u01ffa-zA-Z0-9 '_-]+$/
        };
    },
    getPasswordMinLength: function() {
        return 8;
    }
}


// WEBPACK FOOTER //
// ./js/legacy/helper.js